import React from "react";
import useProduct from "../../../../../Hook/useProduct";
import { Link } from "react-router-dom";
import Rating from "@mui/material/Rating";
import Button from "@mui/material/Button";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

const FishFood = () => {
  const { categories } = useProduct(
    `https://rocky-earth-23971.herokuapp.com/products?categories=${"fish-food"}`
  );
  return (
    <div className="container my-5">
      <div className="row">
        <p className="text-muted my-3">
          বিভিন্ন প্রকারের মাছ থাকবে এ ক্যাটাগরিতে। পুকুরে চাষ, চলনবিলসহ বিভিন্ন
          বিল এবং সিলেটের হাওরের দেশী মাছ ও সামুদ্রিক মাছের ছড়াছড়ি থাকবে এ
          তালিকায়। এছাড়া দক্ষিণাঞ্চলের চিংড়ি ও শুটকিসহ চট্টগ্রামের শুটকিও পাওয়া
          যাবে আয়েশ ফিস এ। পচনশীল ও মান এবং সময়ভেদে দামের ভিন্নতা থাকবে পণ্যে।
        </p>
      </div>
      <div className="row g-4">
        <hr />
        <p className="text-center display-6 text-muted">Fish Food Products</p>
        <hr />
        {categories.map((data) => (
          <div className="col-sm-6 col-md-4 col-lg-3" key={data._id}>
            <div className="card h-100">
              <div className="card p-2  shadow">
                <img src={data.imageFile} alt="imageFile" height="200" />
              </div>
              <div className="p-3">
                <Link to="/">
                  <h5 className="text-capitalize mt-3">{data.productTitle}</h5>
                </Link>
                <div className="my-3">
                  <Rating name="read-only" value={3} readOnly />
                </div>
                <div className="d-flex justify-content-between">
                  <Button variant="contained">Add to cart</Button>
                  <Button variant="outlined">
                    <FavoriteBorderIcon />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FishFood;
